//剩余时间
const remainingTime = val => {
    var days = Math.floor(val / (24 * 3600 * 1000));
    days = days > 0 ? days : 0;
    var hours = Math.floor((val % (24 * 3600 * 1000)) / (3600 * 1000));
    hours = hours > 0 ? hours : 0;
    return `${days}天${hours}小时`;
}
export { 
    remainingTime
}